module.exports = __webpack_public_path__ + "img/cmg.9858915b.png";